import React from 'react';

import { twMerge } from 'tailwind-merge';

interface ModalProps {
  onClose: () => void;
}

const HowToLaunch: React.FC<ModalProps> = ({ onClose }) => {
  return (
    <div
      className={twMerge(
        'fixed w-full inset-0 flex items-center justify-center z-50 backdrop-blur-md mt-auto mb-auto',
      )}
    >
      <div className="flex w-full max-w-[480px] sm:max-w-xl flex-col p-6 rounded-lg gap-3 bg-[#13141D] relative font-meme">
        <div className="">
          <h2 className="text-[24px] font-medium">How to Launch your Token</h2>
          <div className="mt-4 mb-8 text-[16px] text-[#9192A0]">
            @GNRTtoken on X with [NAME] [TICKER] [UPLOAD IMAGE] and tag
            #DEGENMODE to launch your token. Include your SOL address... GNRT
            token will reply to your request with a link to your token and
            trading will begin immediately.
          </div>

          <button
            onClick={() => onClose()}
            className="absolute top-6 right-6 text-gray-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M13.5909 12.5L18.0441 8.04687C18.2554 7.8359 18.3743 7.54962 18.3745 7.25099C18.3748 6.95237 18.2564 6.66587 18.0455 6.45453C17.8345 6.24319 17.5482 6.12431 17.2496 6.12404C16.951 6.12378 16.6645 6.24215 16.4531 6.45312L12 10.9062L7.54687 6.45312C7.33553 6.24178 7.04888 6.12305 6.75 6.12305C6.45111 6.12305 6.16447 6.24178 5.95312 6.45312C5.74178 6.66447 5.62305 6.95111 5.62305 7.25C5.62305 7.54888 5.74178 7.83553 5.95312 8.04687L10.4062 12.5L5.95312 16.9531C5.74178 17.1645 5.62305 17.4511 5.62305 17.75C5.62305 18.0489 5.74178 18.3355 5.95312 18.5469C6.16447 18.7582 6.45111 18.8769 6.75 18.8769C7.04888 18.8769 7.33553 18.7582 7.54687 18.5469L12 14.0937L16.4531 18.5469C16.6645 18.7582 16.9511 18.8769 17.25 18.8769C17.5489 18.8769 17.8355 18.7582 18.0469 18.5469C18.2582 18.3355 18.3769 18.0489 18.3769 17.75C18.3769 17.4511 18.2582 17.1645 18.0469 16.9531L13.5909 12.5Z"
                fill="#9192A0"
              />
            </svg>
          </button>
          <div className="flex relative mt-6">
            <div className="absolute left-[16px] top-0 h-full border border-dashed border-[#585A6B]"></div>
            <div className="flex flex-col gap-6 z-10">
              <div className="flex  gap-4 text-[14px] text-[#E8E9EE]">
                <div className="p-[10px] w-8 h-8 flex items-center justify-center rounded-full bg-[#1A1C28]">
                  1
                </div>
                <div>
                  <div className="text-[20px]">Creator Incentives</div>
                  <div className="text-[#9192A0] text-[16px]">
                    <span>
                      Upon graduation to Raydium token creators will receive:
                    </span>
                    <ul>
                      <li>- 1% of the token</li>
                      <li>- 20% bonding curve txn fees of the token</li>
                      <li>
                        - 30% bonding curve txn fees once 10M mcap is reached
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flex  gap-4 text-[14px] text-[#E8E9EE]">
                <div className="p-[10px] w-8 h-8 flex items-center justify-center rounded-full bg-[#1A1C28]">
                  2
                </div>
                <div>
                  <div className="text-[20px]">$GNRT Staking Incentives</div>
                  <div className="text-[#9192A0] text-[16px]">
                    <span>
                      0.5% shared allocation of all launched tokens which are
                      claimable once a token is launched.
                    </span>
                    <span>
                      Upon graduation to Raydium $GNRT stakers will receive:
                    </span>
                    <ul>
                      <li>- 10% bonding curve txn fees</li>
                      <li>
                        - 50% bonding curve txn fees once 10M mcap is reached
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flex  gap-4 text-[14px] text-[#E8E9EE]">
                <div className="p-[10px] w-8 h-8 flex items-center justify-center rounded-full bg-[#1A1C28]">
                  3
                </div>
                <div>
                  <div className="text-[20px]">
                    $MAX Strongbox Staking Incentives
                  </div>
                  <div className="text-[#9192A0] text-[16px]">
                    <span>
                      Upon2% shared allocation of all launched tokens which are
                      claimable once a token is launched.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToLaunch;
